export default {
	text: {
		addButton: 'Add',
		addFile: 'Add attachment',
		addAdInfo: 'Add additional information',
		addedFrom: 'Added by ',
		approveRequestButtonInfo: 'Allow access',
		area: 'Area',
		areaAssociation: 'Area-Association',
		all: 'All',
		approvalStateItems: {
			created: 'created',
			openForApproval: 'requested',
			editing: 'editing',
			approved: 'approved',
			declined: 'declined',
			canceled: 'canceled',
		},
		allowedFormats: {
			jpg: 'JPEG-File (.jpeg, .jpg)',
			png: 'PNG-File (.png)',
			html: 'HTML-File (.html)',
			pdf: 'PDF-File (.pdf)',
			doc: 'Word-Document (.doc, .docx)',
			xls: 'Excel-Table (.xls)',
			txt: 'Text-File (.txt)',
		},
		attachmentType: {
			text: 'Text',
			file: 'File',
			link: 'Link',
		},
		abortNoSave: 'Abort without save',
		abort: 'Abort',
		adjustDef: 'Adjust definitions',
		additionalFilter: 'additional filters',
		additionalConactInfo: 'Additional contantinformation',
		additionaltInfo: 'additional informations',
		additionalConactInfoPlaceholder: 'e.g. secondary contact person, times...',
		addStreet: 'Addition',
		approval: 'Approval',
		approve: 'Approve',
		approceDecline: 'approve/decline',
		apply: 'Apply',
		bestPerfOnly: 'only best performance by athlete',
		backButton: 'Back',
		bestlist: 'Bestlist',
		bestlistTitle: 'Bestlists',
		bestListsLoading: 'bestlists loading',
		bestResult: 'Result',
		backToOverview: 'back to overview',
		category: 'Category',
		confirmTitle: 'Confirm',
		confirmation: 'Your account is now activated. You can log in now',
		confirmPassword: 'Confirm password',
		createButton: 'Create',
		createAndNew: 'Save and new',
		createAndClose: 'Save and close',
		createAndNext: 'Save and next',
		createCustom: 'create self',
		createApprovalHint1: 'Mit dem Anschicken bestätigt der Veranstalter die Kenntnisnahme der <a href="https://www.dlv-event.de/Files/event-info.pdf" target="_blank">Hinweise</a> und verpflichtet sich zu Beachtung der dort angegebenen Auflagen sowie zur Einhaltung der DLV-Satzung und Ordnung, der darin enthaltenen DLV-Anti-Doping-Codes (ADC), der Deutschen Leichtathletikordnung (DLO), der Gebührenordnung (GBO) sowie zur Einhaltung der Internationalen Wettkampfregeln (IWR). Der Veranstalter verpflichtet sich des Weiteren, Teilnehmer seiner Veranstaltung schriftlich darauf hinzuweisen, dass dieser mir der Teilnahme die Geltungen des DLV-Anti-Doping-Codes (DLV-ADC) anerkennt und sich dessen Bestimmungen unterwirft. ',
		createApprovalHint2: 'Er erklärt sich auch damit einverstanden, dass vorgenannte Veranstaltung einschließlich der genannten Kontaktdaten in den DLV- und LV-Publikationen, sowie den Internetseiten www.leichthletik.de, www.laufen.de (nur Laufveranstaltungen) und des eigenen LV veröffentlicht werden kann, Dieses gilt auch für die Ergebnisse zur Erstellung von Bestenlisten.',
		createApprovalHint3: 'Hier können Sie Ausschreibung, Zeitplan und Ergebnislisten hochladen.',
		createApprovalHint4: 'Hierfür klicken Sie auf „Datei hinzufügen“ und wählen dann aus, ob Sie einen Link auf der Homepage eingeben, oder eine Datei hochladen wollen. Dann füllen Sie alle 4 offenen Felder aus. „Titel“ – so heißt die Datei/Link bei Veröffentlichung im Internet, unter „Gruppe“ wählen Sie das Themengebiet zu dem die Datei/Link gehört, „Sort“ steht für die Sortierreihenfolge in der die Daten/Links angezeigt werden sollen (1 = an erster Stelle usw.). Bei „Link“ tragen Sie den Link zu einer Homepage ein, bei „Datei“ laden Sie über „Durchsuchen“ eine Datei von Ihrem PC hoch oder bei „Text“ geben Sie den gewünschten Fließtext ein.',
		createApprovalHint5: 'Erlaubte Dateiformate sind:',
		compApprovalFinisherHint1: 'Bitte tragen Sie hier die Gesamtfinisher (über alle Disziplinen, Streckenlängen und Bewegungsformen) Ihrer Veranstaltung ein:',
		compApprovalFinisherHint2: 'Einmal erfasst, können die Finisherzahlen nur noch vom {LV} geändert werden!',
		compApprovalFinisherHint3: 'Bitte tragen Sie hier die Gesamtzahl Ihrer Veranstaltung ein:',
		compApprovalFinisherHint4: 'An welche Adresse solld ie Rechnung versendet werden?',
		createTime: 'Created',
		competitionContact: 'Kontakt d. Veranstaltung',
		class: 'Class',
		cancel: 'cancel',
		classes: 'Classes',
		classesSelected: ' Classes selected',
		closingDate: 'Meldeschluss',
		checkingLoading: 'Checking loading',
		checkingTitle: 'Checking',
		competition: 'Competition',
		createdFrom: 'Created by',
		createdOn: 'Created on',
		copy: 'copy',
		copyFrom: 'copy from',
		competitionId: 'WK-ID',
		competitionNotPassed: 'Die Veranstaltung ist noch nicht beendet',
		competitionFinisherRecorded: 'Finisher-Zahlen wurden bereits erfasst',
		competitionLocation: 'Competitionlocation',
		compApprovalBillingInfo: 'Sind Sie ein gemeinnütziger Veranstalter und werden alle Einnahmen aus Start/-Teilnehmergebühren der Veranstaltung unmittelbar mildtätigen Zwecken im Sinne von §53 AO, §4 Nr. 18 UStG zugeführt?',
		compApprovalBillingUsage: 'Mildtätigen Zweck angeben',
		compApprovalFeeInfo: 'Start-/Teilnehmergebühren werden erhoben',
		competitionApprovalRequest: 'Enter competition',
		company: 'Firma',
		competitionApproval: 'Wettkampfgenehmigung',
		competitionApprovalType: {
			all: 'Stadionfern - alle',
			nonStadiaMeasured: 'Stadionfern - vermessen',
			nonStadiaNonMeasured: 'Stadionfern - nicht vermessen',
			nonStadiaMixedMeasured: 'Stadionfern - gemischt',
		},
		competitionApprovalArt: {
			streetRun: 'Straßen-/Landschaftslauf',
			crossCountry: 'Cross-/Waldlauf',
			mountainRun: 'Berg-/Geländelauf',
			streetWalk: 'Straßengehen (Wettkampfgehen, kein Walking',
			else: 'Sonstige (Bsp: Trail, Adventure-Lauf, Duathlon...)',
			peoplesRun: 'Volkslauf',
		},
		competitionGroups: {
			w: 'Frauen',
			m: 'Männer',
			w20: 'WJU20/U18',
			m20: 'MJU20/U18',
			w16: 'WJU16/U14',
			m16: 'MJU16/U14',
			w12: 'WKU12 und jünger',
			m12: 'MKU12 und jünger',
			wsen: 'Seniorinnen',
			msen: 'Senioren',
			sumRun: 'davon Läufer',
			sumInline: 'davon Anzahl sonstige (z.B.: Inline, Wandern, ...)',
			sumNordic: 'davon Anzahl (Nordic-) Walker',
		},
		competitionApprovalTitle: 'Wettkampfgenehmigung',
		competitionApprovalCategorryArt: 'Kategorie und Art',
		competitionApprovalEvClMatrix: 'Event-Klassen Kombinationen',
		competitionApprovalEventClass: 'Agegroups and Disciplines',
		competitionApprovalAttachments: 'Dateien und Links',
		competitionApprovalDetailView: 'Competitiondetails',
		competitionLoading: 'Competition loading',
		competitionTitle: 'Competition',
		competitionCategory: {
			free4all: '00.0 Breitensport',
			club_Sportfest: '1.1 Sportfest vereinsoffen',
			area_Championship: '2.1 Kreismeisterschaft',
			area_Sportfest: '2.2 Sportfest kreisoffen',
			district_Championship: '3.1 Bezirksmeisterschaft',
			district_Sportfest: '3.2 Sportfest bezirksoffen',
			region_Championship: '4.1 Landesmeisterschaft',
			region_Sportfest: '4.2 Sportfest landesoffen',
			region_Sportfest_Bordering: '4.4 Sportfest landesoffen + 1 weiterer LV',
			national_Championship: '5.1 Deutsche Meisterschaft',
			national_Sportfest: '5.2 Sportfest national',
			national_Invitational: '5.3 Einladungssportfest national',
			national_Runevent: '5.4 Nationale Laufveranstaltung',
			international_InvitationalWalking: '6.4 Einladungssportfest Gehen',
			international_Runevent: '6.6 Internationale Laufveranstaltung',
			iAAF_Runevent: '8.3 Internationale Laufveranstaltung mit EA- oder WA-LABEL',
		},
		createInvoice: 'Rechnung erstellen',
		courseLength: 'Courselength',
		competitor: 'Athlete',
		gerCompetitionId: 'German Competitionnumber',
		club: 'Club',
		country: 'Nation',
		customEvents: 'Custom Events',
		customEventLabels: {
			run: 'Lauf',
			walk: 'Walking',
			nordicWalking: 'Nordic Walking',
			mixedWalking: 'Walking/Nordic Walking (gleiche Streckenlänge)',
			hiking: 'Wandern',
			inlineSkating: 'Inline Skating',
			wheelChair: 'Rollstuhl',
			timeRun: 'Lauf auf Zeit',
			else: 'Sonstiges',
		},
		dialogText: {
			reallySave: 'Really save?',
			uSure: 'Are you sure?',
		},
		dialog: 'Dialog',
		dashboardTitle: 'LA.Portal Service',
		dashboard: 'LA.Portal Service',
		deleteRolesButton: 'Delete',
		delete: 'Delete',
		deleteRequest: 'Really Delete?',
		details: 'Details',
		dateFrom: 'Date from',
		dateTo: 'Date to',
		download: 'Download',
		dob: 'Birthdate',
		declinePerf: 'Decline performance for bestlist',
		declineChecking: 'Decline checking',
		district: 'Bezirk',
		differentRoute: 'Abweichende Anfahrtsadresse',
		date: 'Date',
		districtAssociation: 'Bezirksverband',
		duration: 'Duration',
		eventType: {
			genericRun: 'Run', // Single
			verticalJump: 'Verticaljump', // Single
			horizontalJump: 'Horizontaljump', // Single
			throw: 'Throw', // Single
			multi: 'Combined', // Multi
			endurance: 'Endurance', // Endurance
			dmm: 'Deutsche Mannschaftsmeisterschaft',
			cup: 'Cup',
			children: 'Kinderleichtathletik',
			multiTeam: 'Mehrkampf-Mannschaft',
			sprintRun: 'Sprint',
			roundRun: 'Rundlauf',
			hurdleRun: 'Hürdenlauf',
			multiCup: 'SVM-Mehrkampf',
			enduranceTeam: 'Lauf-Mannschaft',
		},
		eventlocation: 'Location',
		editTime: 'Edit-Time',
		email: 'Email',
		endAge: 'End-Age',
		endDate: 'End-Date',
		environment: 'Environment',
		errorInvalidInput: 'Invalid input',
		errorEmpty: 'can not be empty',
		errorFirstNameRequired: 'Firstname required',
		errorLastNameRequired: 'Lastname required',
		errorEmailRequired: 'Email required',
		errorEndBeforeStart: 'Enddate can not be before Startdate',
		errorEventTooLong: 'Competition can not be 100 days long',
		errorStartDateInvalid: 'Startdate invalid',
		errorInvalidEmail: 'Muss eine gültige E-Mail sein',
		errorPasswordRequired: 'Passwort wird benötigt',
		errorConfirmPasswordRequired: 'Passwort bestätigen ist erforderlich',
		errorLanguageRequired: 'Sprache ist erforderlich',
		errorOrganizationRequired: 'Organisation ist erforderlich',
		errorRoleRequired: 'Rolle ist erforderlich',
		errorReasonRequired: 'Grund ist erforderlich',
		errorUserRequired: 'Benutzer erforderlich',
		errorNameRequired: 'Name ist erforderlich',
		errorCompetitorRequired: 'Teilnehmer erforderlich',
		errorBestResultRequired: 'Ergebnis erforderlich',
		errorShouldBeTime: 'Eingabe entspricht nicht dem richtigen Format (00:00:00.00)',
		errorShouldBeDecimal: 'Eingabe entspricht nicht dem richtigen Format (+/-00.00)',
		errorShouldBeNumber: 'Eingabe entspricht nicht dem richtigen Format (+0000)',
		errorClassDefRequired: 'Agegroup required',
		errorEventRequired: 'Event erforderlich',
		errorResultDate: 'Datum erforderlich',
		errorCompetitionRequired: 'Competition required',
		errorNationRequired: 'Nation erforderlich',
		errorEnvironmentRequired: 'Environment required',
		errorTownRequired: 'Stadt erforderlich',
		error404: 'Angeforderte Daten nicht gefunden, überprüfen Sie die Richtigkeit der eingegebenen Daten',
		error403: 'Sie haben keinen Zugriff auf diese Ressource',
		error400: 'Falsche Daten, bitte überprüfen Sie die Richtigkeit der Daten',
		error422: 'Nicht verarbeitbare Daten, bitte überprüfen Sie die von Ihnen angegebenen Daten',
		error500: 'Server funktioniert nicht, bitte wenden Sie sich an den Administrator',
		errorDateFromRequired: 'Date required',
		errorDateToRequired: 'Date required',
		errorMinZero: 'darf nicht kleiner 0 sein',
		errorMinOne: 'darf nicht kleiner 1 sein',
		errorMax12: 'darf nicht größer 12 sein',
		errorMax31: 'darf nicht größer 31 sein',
		errorSum: 'Die Summen beider angaben müssen übereinstimmen',
		errorInvalidUrl: 'Adresse ist nicht gültig',
		expandButton: 'Alle erweitern',
		editCompApprovalREQUEST: 'Der Wettkampf wurde bereits genehmigt. Durch das Bearbeiten könnte er diesen Status verlieren. Sind Sie sicher, dass sie fortfahren wollen?',
		editCompApprovalHINT: 'Es wurden Änderungen vorgenommen, die zum Erlöschen der Genehmigung führen. Sind Sie sicher, dass Sie diese speichern wollen',
		editCompApprovalDeleteHINT: 'Sind Sie sicher, dass Sie den Wettkampf löschen wollen? Dieser Schritt kann nicht mehr rückgängig gemacht werden!',
		event: 'Discipline',
		eventRegistration: 'Competition-Registration',
		events: 'Disciplines',
		eventMaxPeople: 'Maximale Teilnehmer',
		eventsSelected: ' Disciplines selected',
		eventClassDef: 'Discipline/Agegroup-Definition',
		edit: 'Edit',
		editLow: 'Edit',
		editedFrom: 'Zuletzt geändert von ',
		fax: 'Fax',
		fileTitle: 'Titel',
		fileSort: 'Sortierung',
		fileGroup: 'Gruppe',
		firstTimeEvent: 'Erstveranstaltung',
		from: 'von',
		forgotPasswordTitle: 'Passwort vergessen',
		forgotPasswordButton: 'Passwort vergessen',
		forgotPasswordSuccess: 'Bitte überprüfen Sie Ihre E-Mails, um Ihr Passwort zurückzusetzen.',
		firstName: 'Vorname',
		filterButton: 'Filter',
		finishButton: 'Fertig',
		finisherNumbers: 'Finisherzahlen erfassen',
		fromDlo: 'nach DLO',
		fromPreset: 'kopieren von anderer Bestenliste',
		fileGroups: {
			tender: 'Ausschreibung',
			online: 'Online-Anmeldung',
			schedule: 'Zeitplan',
			entries: 'Teilnehmer',
			infos: 'Weitere Informationen',
			else: 'Sonstiges',
			live: 'Live-Ergebnisse',
			results: 'Ergebnisse',
			moreLA: 'Mehr auf leichtathletik.de',
			elseLA: 'Sonstiges leichtathletik.de',
			liveOwner: 'Live-Ergebnisse',
			resultsOwner: 'Ergebnisse',
		},
		gps1: 'GPS (Lat)',
		gps2: 'GPS (Lng)',
		genderLable: 'Geschlecht',
		gender: {
			m: 'Männlich',
			f: 'Weiblich',
			mixed: 'Mixed',
		},
		generate_invoice: 'Rechnung generieren',
		handTime: 'Handtime',
		headerHash: '#',
		headerCreatedAt: 'Created at',
		headerChangedAt: 'Changed at',
		headerOrganization: 'Organization',
		headerUser: 'User',
		headerCompetitor: 'Athlete',
		headerCompetitionName: 'Competitionname',
		headerCompetitionLocation: 'Competitionlocation',
		headerCompetitionDate: 'Competitiondate',
		headerContactAddress: 'Kontaktadresse für die Veranstaltung (wird veröffentlicht)',
		headerRole: 'Role',
		headerStatus: 'Status',
		headerReason: 'Reason',
		headerActions: 'Actions',
		headerOrganizationName: 'Organizationname',
		headerBestlistName: 'Name',
		headerRegionalRestriction: 'Regional-Restriction',
		headerPerfListName: 'Name of List',
		headerBestResult: 'Result',
		headerBestWind: 'Wind',
		headerEventShortNational: 'Discipline',
		headerHeightWeight: 'Height-Weight',
		headerPerformanceDateTime: 'Datum',
		headerPerformanceCompetitionName: 'Competition',
		headerPerformanceCompetitionTown: 'Town',
		headerPerformanceOrganizationName: 'Club',
		headerPerformanceCreatorUser: 'Source',
		headerStatisticData: 'Statistische Daten',
		headerName: 'Name',
		headerYob: 'Year of Birth',
		headerDateFrom: 'Date from',
		headerDateTo: 'Date until',
		headerTown: 'Town',
		headerLocation: 'Stadion',
		headerNation: 'Nation',
		headerArea: 'Area',
		headerDistrict: 'District',
		headerStateCode: 'LV-Kürzel',
		heightWeight: 'Height-Weight',
		homepage: 'Website',
		handtime: 'Handtime',
		hintNeedProtocol: 'Bitte vergessen Sie nicht, das Vermessungsprotokoll für jeden Bewerb anzugeben!',
		hintMustAgree: 'Durch die Registrierung stimmen Sie den Nutzungsvereinbarungen sowie der Zustellung servicerelevanter E-Mails zu. ',
		hintNewsletter: 'Ja, ich möchte Produktneuigkeiten und andere interessante News per Newsletter erhalten.',
		indoor: 'Indoor',
		inMeter: 'in Meter',
		inKMeter: 'in KM',
		invoice: 'Rechnung',
		invoiceDate: 'Rechnung ausgestellt',
		insertCompetition: 'Genehmigung beantragen',
		insertSearchText: 'Text eingeben um Suche zu starten',
		kind: 'Art',
		km: 'km',
		lastEditedOn: 'Zuletzt bearbeitet am',
		location: 'Ort',
		loginTitle: 'Login',
		login: 'Login',
		license: 'Lizenz',
		logout: 'Ausloggen',
		loginButton: 'Login',
		lastName: 'Nachname',
		language: 'Sprache',
		licenseTitle: 'Lizenz',
		measurementProtocol: 'Vermessungsprotokoll',
		licenseButton: 'Herunterladen',
		masterorganization: 'Dachverband',
		multiRecordLable: 'Innerhalb eines Mehrkampfes erbracht',
		mr: 'Herr',
		mrs: 'Frau',
		mob: 'Geburtsmonat',
		mobile: 'Mobil',
		noButton: 'Nein',
		next: 'Weiter',
		none: 'keine',
		noDataFound: 'Keine Einträge gefunden',
		newAccount: 'Neuen Account anlegen',
		newPerformance: 'New Performance',
		newRequestButton: 'Neue Anfrage',
		newBestList: 'New Bestlist',
		newCompetitionApproval: 'Neuer Wettkampf',
		newCompetitionApprovalTitle: 'Neuer Wettkampf',
		newRoleButton: 'Neue Rolle',
		newUserRoleTitle: 'Neue Benutzerrolle',
		newRoleRequestTitle: 'Neue Rollenanforderung',
		newRoleRequestAdminInfo: 'Diese Organisation hat keinen Administrator. Fordern Sie jetzt die Administratorberechtigung an oder bitten Sie den Verband um Hilfe',
		newBestListTitle: 'New Bestlist',
		newPerformanceInfo: 'New performance created',
		newChecking: 'New Checking',
		newCheckingTitle: 'New Checking',
		newCompetitionTitle: 'New Competition',
		newCompetition: 'New Competition',
		newPerformanceTitle: 'New Performance',
		notDecidedChecking: 'Set negative',
		negativeChecking: 'Set undecided',
		nationalAthleteCode: 'National Athlete-Code',
		name: 'Name',
		messageSent: 'Nachricht versandt',
		nation: 'Nation',
		outdoor: 'Outdoor',
		organization: 'Organisation',
		organisator: 'Veranstalter',
		organizationName: 'Verein/Organisation',
		on: ' am ',
		otherContact: 'andere Adresse eingeben',
		ok: 'OK',
		originCountry: 'Herkunftsland',
		place: 'Ort',
		zip: 'PLZ',
		password: 'Passwort',
		perfTime: 'Performancedate',
		performance: 'Performances',
		performanceTitle: 'Performances',
		performanceLoading: 'Performances loading',
		performanceList: 'Performancelist',
		points: 'Points:',
		phone: 'Telefon',
		protocollAtDlvLv: 'Liegt dem DLV und LV vor',
		reloading: 'Lade neu...',
		register: 'Registrieren',
		registerTitle: 'Registrieren',
		registerButton: 'Registrieren',
		registrationSuccess: 'Danke für Ihre Registrierung. Bitte bestätigen Sie die E-Mail die an Sie gesendet wurde.',
		relayMembers: 'Staffel-Teilnehmer',
		resetPasswordTitle: 'Passwort zurücksetzen',
		resetPasswordButton: 'Passwort zurücksetzen',
		resetPasswordSuccess: 'Ihr Passwort wurde erfolgreich zurückgesetzt. Sie können sich jetzt mit Ihrem neuen Passwort einloggen.',
		rejectRoleRequestTitle: 'Rollenanforderung ablehnen',
		rejectRoleReason: 'Grund',
		rejectButton: 'Ablehnen',
		role: 'Rolle',
		roleRequestsTitle: 'Rollenanfragen',
		roleRequestsLoading: 'Laden, bitte warten',
		rolerequests: 'Rollenanfragen',
		removeRequestNotification: 'Sind Sie sicher, dass Sie löschen möchten?',
		removeRoleButtonInfo: 'Rolle entfernen',
		removeRequestButtonInfo: 'Anfrage entfernen',
		removeRole: 'Sind Sie sicher, dass Sie löschen möchten?',
		removeLastRoles: 'Möchten Sie wirklich alle Rollen für Benutzer löschen:',
		redirectPerfList: 'Directlink to Bestlist',
		rejectRequestButtonInfo: 'Anfrage ablehnen',
		regionalRestriction: 'Regional-Restriction',
		reportingPortalLink: 'Link zum Meldeportal',
		record: 'Rekord',
		onlyStartingPassAllowed: 'Dürfen an dieser Veranstaltung ausschließlich Startpassinhaber teilnehmen?',
		save: 'Save',
		save_and_send: 'Save & an LV senden',
		spinner: 'Working...',
		sortButton: 'Sortieren',
		setAge4All: 'Set for overall agegroup:',
		send: 'Senden',
		search: 'Search',
		searchButton: 'Search',
		searchPeriod: 'Suchzeitraum',
		stadionName: 'Stadion',
		startAge: 'Start-Age',
		startDate: 'Startdatum',
		startTime: 'Startzeit',
		status: 'Status',
		statistic: 'Statistics',
		stateCode: 'LV-Kürzel',
		streetNr: 'Straße / Hausnummer / Postfach',
		street: 'Straße',
		stopEmails: 'Email-Versand unterdrücken',
		showDetails: 'Details anzeigen',
		startLocation: 'Startplatz',
		stateAssociation: 'Landesverband',
		startTypingSearch: 'Eingabe startet die Suche',
		sum: 'Summe',
		sumOverAll: 'Summe gesamt',
		toLong: 'Eingabe zu Lange. Bitte kürzen.',
		title: 'Anrede',
		timeFormat: 'hh:mm',
		to: 'zu',
		till: 'bis',
		town: 'Stadt',
		type: 'Typ',
		tootltipZeroIsinfinity: '0 (Null) = unbeschränkt',
		unlimited: 'unbeschränkt',
		undecided: 'noch nicht bearbeitet',
		userManagementTitle: 'Benutzerverwaltung',
		userManagementLoading: 'Laden, bitte warten',
		updateRoleButtonInfo: 'Rolle aktualisieren',
		updateBestListTitle: 'Edit Bestlist',
		updatePerformanceTitle: 'Edit Performance',
		updateCompetitionTitle: 'Edit Competition',
		usermanagement: 'Usermanagement',
		user: 'User',
		updateButton: 'Update',
		unsavedData: 'Daten wurden verändert. Diese gehen verloren, wenn Sie nicht spiechern. Wollen Sie fortfahren?',
		unknowen: 'unbekannt',
		yesButton: 'Ja',
		yob: 'Jahrgang',
		year: 'Jahr',
		windResult: 'Wind',
		jobpagesize: 'Count Results',
		jobyear: 'Export Year',
		exportBestListTitle: 'Export Bestlist',
		exportButton: 'Start Export',
		exportPerfList: 'Export',
	},
};
